import React, { Fragment, Component } from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import HeaderLogo from '../AppLogo';
import UserBox from './Components/UserBox';
import { properties } from '../../constants/Propertise';
// import Projects from './Components/Projects';


class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            navMenulist: []
        }
    }

    render() {

        let { headerBackgroundColor, enableMobileMenuSmall, enableHeaderShadow } = this.props;
        return (
            <Fragment>
                <ReactCSSTransitionGroup
                    component="div"
                    className={cx("app-header", headerBackgroundColor, { 'header-shadow': enableHeaderShadow })}
                    transitionName="HeaderAnimation"
                    transitionAppear={true}
                    transitionAppearTimeout={1500}
                    transitionEnter={false}
                    transitionLeave={false}>

                    <HeaderLogo />

                    <div className={cx(
                        "app-header__content",
                        { 'header-mobile-open': enableMobileMenuSmall },
                    )}>
                        {/* <div className="app-header-left">
                            <Projects />
                        </div> */}

                        <div className="app-header-right">
                            <div className="header-btn-lg pr-0 hideMibile">
                                <div className="widget-content p-0">
                                    <div className="widget-content-wrapper">
                                        <div className="widget-content-left">
                                            <span className="widget-heading">
                                                {/* <span className="widget-heading">{properties.projectName}</span> */}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <UserBox />
                        </div>
                    </div>
                </ReactCSSTransitionGroup>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    enableHeaderShadow: state.ThemeOptions.enableHeaderShadow,
    closedSmallerSidebar: state.ThemeOptions.closedSmallerSidebar,
    headerBackgroundColor: state.ThemeOptions.headerBackgroundColor,
    enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Header);